// Shared gate for the "Go to page" control.
//
// DataTables owns its page buttons and renders a windowed subset of them, so
// the only honest way to know whether a page is unreachable is to count the
// numbered buttons it actually rendered. Deriving the window size from
// pagingType would go stale the moment that option changes.

/**
 * Number of real, numbered page buttons DataTables rendered inside `container`.
 * The ellipsis button carries the same class, and the labels are locale
 * formatted ("4,065"), so match digits and separators only.
 */
export const countRenderedPageButtons = (container: Element | null): number => {
  if (!container) return 0;
  return Array.from(container.querySelectorAll(".dt-paging-button")).filter(
    (el) => /^[\d,]+$/.test((el.textContent || "").trim())
  ).length;
};

/**
 * Show the control only once a page has no button of its own.
 *
 * A table of one page renders no numbered buttons at all, which would otherwise
 * read as "0 buttons < 1 page" and put a jump input on a list with nowhere to
 * jump to - hence the explicit `totalPages > 1`.
 */
export const shouldShowPageJump = (
  totalPages: number,
  visiblePageButtons: number
): boolean => totalPages > 1 && visiblePageButtons < totalPages;
